import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] grid place-content-center bg-bah-paper py-20" data-testid="not-found-page">
      <div className="text-center px-6">
        <div className="eyebrow justify-center inline-flex">404</div>
        <h1 className="mt-4 font-display text-4xl md:text-6xl text-bah-ink leading-tight">
          We can't find that page.
        </h1>
        <p className="mt-3 text-bah-mute max-w-md mx-auto">
          The page you're looking for doesn't exist here. Head back to the
          Biodeal Animal Health home, or talk to the technical team.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary">Back to Home</Link>
          <Link to="/contact" className="btn-ghost-dark">Contact Us</Link>
        </div>
      </div>
    </section>
  );
}
